import React from 'react'
import PropTypes from 'prop-types'

import { getServiceIcon } from '~/shared/utils'

import {
  Wrapper,
  InitialWrapper,
  IconWrapper,
  PlaceholderWrapper,
} from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'username' implicitly has an 'any'... Remove this comment to see the full error message
const AvatarDefault = ({ username, service, placeholder }) => {
  if (placeholder) {
    return <PlaceholderWrapper data-testid="placeholder" />
  }

  if (!username) return null

  const initial = username.charAt(0).toUpperCase()

  return (
    <Wrapper
      data-testid="avatar"
      draggable="false"
      onDragStart={(e) => e.preventDefault()}
    >
      <InitialWrapper data-testid="initial">{initial}</InitialWrapper>
      <IconWrapper data-testid="icon">
        {getServiceIcon(service, 'medium')}
      </IconWrapper>
    </Wrapper>
  )
}

AvatarDefault.propTypes = {
  username: PropTypes.string,
  service: PropTypes.string,
  placeholder: PropTypes.bool,
}

export default AvatarDefault
